import { render } from "./AutomaticOrderModal.vue?vue&type=template&id=0a024dc9&scoped=true"
import script from "./AutomaticOrderModal.vue?vue&type=script&lang=js"
export * from "./AutomaticOrderModal.vue?vue&type=script&lang=js"

import "./AutomaticOrderModal.vue?vue&type=style&index=0&id=0a024dc9&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a024dc9"]])

export default __exports__